import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "board-view-container d-flex" }
const _hoisted_2 = {
  class: "left",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { style: {"flex":"2","min-width":"800px"} }
const _hoisted_7 = { class: "right" }

import { useApi } from "@/api/handler";
import { game } from "@/api";
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ApiMap } from "@/api/type";
import BoardBox from "@/components/board/BoardBox.vue";
import BoardStatus from "@/components/board/BoardStatus.vue";
import GradeRank from "@/components/board/GradeRank.vue";
import TileRank from "@/components/board/TileRank.vue";
import LegendBox from "@/components/board/LegendBox.vue";
import SpecialCard from "@/components/board/SpecialCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardView',
  setup(__props) {

const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const route = useRoute()
const gameId = ref<number>(0)
const router = useRouter()
const rewardMode = ref<{ rewardId: string; teamId: number; stepCount: number } | null>(null)

const originX = ref(70)
const originY = ref(40)
const radius = ref(24)

onMounted(() => {
  gameId.value = Number(route.query.id)
  useGameStatus()
})

watch(() => GameStatus.value, newVal => {
  if (!newVal) return
  if (newVal.stage >= 2) router.push({ path: '/proposal', query: { id: newVal.id } })
})

const useGameStatus = () => {
  useApi({
    api: game.GameStatus(gameId.value),
    onSuccess: resp => {
      GameStatus.value = resp.data as ApiMap['/game/status/:id']['resp']
    }
  })
}

const handleStartIssueReward = (payload: { rewardId: number; teamId: number; stepCount: number }) => {
  rewardMode.value = payload
}

const handleRewardConfirm = (payload: { rewardId: number; tileIds: number[] }) => {
  if (!GameStatus.value) return
  useApi({
    api: game.IssueReward({ rewardId: payload.rewardId, gameId: GameStatus.value.id, tileIds: payload.tileIds }),
    onSuccess: () => {
      rewardMode.value = null
      useGameStatus()
    },
    tip: '奖励发放成功，棋盘状态已更新'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_expansion_panels, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, { class: "mt-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_title, { class: "pa-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-cog",
                    class: "mx-4"
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-h6" }, "棋盘设置", -1))
                ]),
                _: 1,
                __: [3]
              }),
              _createVNode(_component_v_expansion_panel_text, { class: "pa-2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mx-2" }, "调整X轴方位", -1)),
                    _createVNode(_component_v_slider, {
                      modelValue: originX.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((originX).value = $event)),
                      max: 240,
                      min: 0,
                      step: 10,
                      "thumb-label": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mx-2" }, "调整Y轴方位", -1)),
                    _createVNode(_component_v_slider, {
                      modelValue: originY.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((originY).value = $event)),
                      max: 240,
                      min: 0,
                      step: 10,
                      "thumb-label": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mx-2" }, "调整棋盘大小", -1)),
                    _createVNode(_component_v_slider, {
                      modelValue: radius.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((radius).value = $event)),
                      max: 34,
                      min: 10,
                      step: 1,
                      "thumb-label": ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SpecialCard, {
        data: GameStatus.value,
        onUpdate: useGameStatus,
        onStartIssueReward: handleStartIssueReward
      }, null, 8, ["data"]),
      _createVNode(TileRank, {
        "enable-edit": true,
        "max-height": 400,
        data: GameStatus.value,
        "show-change": ""
      }, null, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (GameStatus.value)
        ? (_openBlock(), _createBlock(BoardBox, {
            key: 0,
            data: GameStatus.value,
            "origin-x": originX.value,
            "origin-y": originY.value,
            radius: radius.value,
            "reward-mode": rewardMode.value,
            onUpdate: useGameStatus,
            onRewardConfirm: handleRewardConfirm
          }, null, 8, ["data", "origin-x", "origin-y", "radius", "reward-mode"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(LegendBox),
      (GameStatus.value)
        ? (_openBlock(), _createBlock(BoardStatus, {
            key: 0,
            data: GameStatus.value,
            onUpdate: useGameStatus
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (GameStatus.value)
        ? (_openBlock(), _createBlock(GradeRank, {
            key: 1,
            "game-id": gameId.value,
            data: GameStatus.value,
            onUpdate: useGameStatus
          }, null, 8, ["game-id", "data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})